// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"wrapper-XLB9e"};